import React from 'react';

const LearnositySharedPassageTemplate = () => {
  return (
    <div type="text/template" data-lrn-qe-layout="sharedpassage-layout" hidden>
      <h5 className="lrn-qe-heading">Passage or Stimulus</h5>

      <div className=" lrn-qe-edit-form">
        <h5 className="lrn-qe-heading">Heading</h5>
        <span data-lrn-qe-input="heading" className="lrn-qe-ckeditor-lg" />

        <h5 className="lrn-qe-heading">Content</h5>
        <span data-lrn-qe-input="content" className="lrn-qe-ckeditor-lg" />
      </div>
    </div>
  );
};

export default LearnositySharedPassageTemplate;
